<section class="w-auto mb-1" [ngClass]="{'rounded-[20px]': !matchesPrevious() && !matchesNext(), 'rounded-t-[20px]': matchesPrevious(), 'rounded-b-[20px]': matchesNext(), '!rounded-none': matchesPrevious() && matchesNext(), 'cursor-pointer': multiselectEnabled()}" [ngStyle]="{'background-color': getCardColor()}" (click)="onCardClick($event)">
    <article class="p-3">
        <div class="relative">
            <div [ngStyle]="{'background-color': getCardColor()}"
                 [ngClass]="{'brightness-110': modifyTimes, 'hover:brightness-110': !multiselectEnabled()}"
                 class="relative flex p-[2px] h-8 items-center mb-3 transition duration-200 rounded-[5px] cursor-pointer"
                 (click)="editTimes()">
                @if (!multiselectEnabled()) {
                    <img [src]="images.setup.card.time" class="w-5 h-5">
                } @else {
                    <input type="checkbox" class="absolute right-0" [checked]="checked()" (change)="checkDay.emit(id())" />
                }
                @if (!modifyTimes) {
                    <label [id]="'time-'+data()?.id" class="ml-1 mr font-extrabold text-base truncate cursor-pointer"
                        [tooltip]="utilsService.visibleTooltip('time-'+data()?.id) ? getTimeRange() : ''" [visibleTooltip]="utilsService.visibleTooltip('time-'+data()?.id)" [position]="TooltipPosition.DYNAMIC">{{ getTimeRange() }}</label>
                }
            </div>
            @if (modifyTimes) {
                <div [id]="'times-' + id()" class="flex ml-6 mt-[-37px] absolute z-10" (focusout)="closeEditMode($event, 'times')">
                    <app-input  class="w-full text-base"
                                [data]="getTimeObject(moment(data()?.startTime, 'HH:mm:ss').format('HH:mm'))"
                                [edit]="true"
                                [independent]="true"
                                (change)="changeData($event, 'startTime')" />
                    <app-input  class="w-full"
                                [data]="getTimeObject(moment(data()?.endTime, 'HH:mm:ss').format('HH:mm'))"
                                [edit]="true"
                                [independent]="true"
                                (change)="changeData($event, 'endTime')" />
                </div>
            }
        </div>
        <div class="relative">
            <div [ngStyle]="{'background-color': getCardColor()}"
                 [ngClass]="{'brightness-110': modifyDriver, 'hover:brightness-110': !multiselectEnabled()}"
                 class="flex p-[2px] h-8 items-center mb-1 transition duration-200 rounded-[5px] cursor-pointer"
                 (click)="editDriver()">
                <img [src]="images.setup.card.driver" class="w-5 h-5">
                @if (!modifyDriver) {
                    <label [id]="'driver-'+data()?.id" class="ml-1 font-normal text-base whitespace-nowrap truncate cursor-pointer"
                        [tooltip]="utilsService.visibleTooltip('driver-'+data()?.id) ? data()?.driver?.name! : ''" [visibleTooltip]="utilsService.visibleTooltip('driver-'+data()?.id)" [position]="TooltipPosition.DYNAMIC">{{ data()?.driver?.name }}</label>
                }
            </div>
            @if (modifyDriver) {
                <div [id]="'driver-select-' + id()" class="flex ml-[18px] mt-[-28px] absolute" (focusout)="closeEditMode($event, 'driver')">
                    <app-driver-select [clientId]="clientId()" [value]="data()?.driver?.id!" [extraOptions]="assignedDriverOption()" (driverSelected)="changeSelection($event, 'driver')" />
                </div>
            }
        </div>
        <div class="relative">
            <div [ngStyle]="{'background-color': getCardColor()}"
                 [ngClass]="{'brightness-110': modifyVehicle, 'hover:brightness-110': !multiselectEnabled()}"
                 class="flex p-[2px] h-8 items-center transition duration-200 rounded-[5px] cursor-pointer"
                 (click)="editVehicle()">
                <img [src]="images.setup.card.vehicle" class="w-5 h-5">
                @if (!modifyVehicle) {
                    <label class="ml-1 font-normal text-base truncate cursor-pointer">{{ data()?.vehicle?.name }}</label>
                }
            </div>
            @if (modifyVehicle) {
                <div [id]="'vehicle-select-' + id()" class="flex ml-[18px] mt-[-24px] absolute" (focusout)="closeEditMode($event, 'vehicle')">
                    <app-vehicle-select [clientId]="clientId()" [value]="data()?.vehicle?.id!" [extraOptions]="assignedVehicleOption()" (vehicleSelected)="changeSelection($event, 'vehicle')" />
                </div>
            }
        </div>
    </article>
</section>
